import { render, staticRenderFns } from "./alarmDialog.vue?vue&type=template&id=2a8e834c&scoped=true"
import script from "./alarmDialog.vue?vue&type=script&lang=js"
export * from "./alarmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e834c",
  null
  
)

export default component.exports